module.exports = __webpack_public_path__ + "media/images/template_dark-aafe57be0cebfd1d2ca7d71d2e2d415c.jpg";